import { Carousel } from "antd";
import caraouselImages from "../../../Data/BannerData/BannerData";
import BannerProducts from "./BannerProducts";

function Banner() {
    const images = caraouselImages.images;
    // console.log(images);
    return (
        <>
            <div className='banner-background d-flex algin-items-center'>
                <div className='container'>
                            <BannerProducts />
                        {/* <div className='col-md-4 col-sm-12 '>
                            <Carousel autoplay dots={false}>
                                {images.map((item) => (
                                    <div key={item.id} className='d-flex justify-content-center'>
                                        <img src={item.image} className="home-carousel"  alt="carousel"/>
                                        Assuming you want to display the image, uncomment the above line
                                    </div>
                                ))}
                            </Carousel>
                        </div> */}
                </div>
            </div>
        </>
    );
}

export default Banner;
